import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { SITE_DOMAIN, SITE_NAME } from './constants/site';
import HomePage from './pages/HomePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RefundPolicy from './pages/RefundPolicy';

const PAGE_TITLES = {
  '/': `${SITE_NAME} - The #1 Selling Genealogy Software`,
  '/privacy-policy': `Privacy Policy | ${SITE_DOMAIN}`,
  '/terms-of-service': `Terms of Service | ${SITE_DOMAIN}`,
  '/refund-policy': `Refund Policy | ${SITE_DOMAIN}`,
};

function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = PAGE_TITLES[pathname] || PAGE_TITLES['/'];
  }, [pathname]);

  return null;
}

function AppRoutes() {
  return (
    <>
      <DocumentTitle />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
